<script lang="ts" setup>
defineOptions({
  name: 'CarouselIndicatorGroup',
});
</script>

<template>
  <div
    class="embla__indicator-group"
    data-scope="carousel"
    data-part="indicator-group"
  >
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
</style>
